// ✨ NOVIDADES DO PORTAL (05/11/2026, Nelson: "nem sempre a pessoa vê"). Recursos novos anunciados no sino, num
// modal e em /novidades — sem depender de e-mail, que só chega a quem já estava cadastrado no dia do comunicado.
//
// Para anunciar algo novo: acrescente NO TOPO, com `id` único e que nunca muda (é ele que marca "visto").
// publico: "candidato" (tipo 0) ou "empresa" (tipo 1).
const NOVIDADES = [
  {
    id: "simulacao-empresa", publico: "empresa", data: "2026-11-05", ic: "🎥",
    titulo: "Candidatos que chegam mais preparados",
    texto: "Indique a simulação de entrevista para quem está no seu processo: sala de vídeo e feedback da IA no fim, de graça. Ou use a sala nas suas próprias entrevistas.",
    cta: "Conhecer a simulação", link: "/simulacao",
  },
  {
    id: "vagas-semelhantes", publico: "candidato", data: "2026-11-04", ic: "🧲",
    titulo: "Uma vaga boa puxa as parecidas",
    texto: "Achou uma vaga com a sua cara? Abra a vaga e clique em \"Ver vagas semelhantes\": você se candidata às parecidas na hora, sem preencher tudo de novo. Todas ficam numa aba só.",
    cta: "Experimentar agora", link: "/vagas",
  },
  {
    id: "simulacao", publico: "candidato", data: "2026-11-04", ic: "🎥",
    titulo: "Treine a entrevista antes da entrevista",
    texto: "Agende uma entrevista de teste, chame alguém para fazer o papel do recrutador e receba o feedback da IA no fim. É de graça, e ninguém de fora vê.",
    cta: "Marcar minha simulação", link: "/simulacao",
  },
  {
    id: "skills-onde-aprender", publico: "candidato", data: "2026-09-28", ic: "🎯",
    titulo: "Falta uma skill para a vaga? A gente mostra onde aprender",
    texto: "Quando a vaga pede Excel, inglês ou uma ferramenta que você ainda não domina, aparece quem ensina, para você chegar pronto.",
    cta: "Ver minhas skills", link: "/curriculo",
  },
  {
    id: "cidades", publico: "candidato", data: "2026-09-16", ic: "📍",
    titulo: "Escolha as cidades onde você aceita trabalhar",
    texto: "Marque as cidades no seu currículo e passe a receber também as vagas presenciais e híbridas de lá, não só as remotas.",
    cta: "Escolher cidades", link: "/curriculo",
  },
  {
    id: "responder-relatos", publico: "empresa", data: "2026-09-20", ic: "💬",
    titulo: "Responda aos relatos sobre a sua empresa",
    texto: "A sua resposta aparece junto do relato, na página pública da empresa, e conta para a reputação.",
    cta: "Ver no painel", link: "/painel",
  },
];

export const publicoDoUsuario = (user) => (user?.tipo === 1 ? "empresa" : user?.tipo === 0 ? "candidato" : null);

export const novidadesPara = (publico) => (publico ? NOVIDADES.filter((n) => n.publico === publico) : []);

// "Visto" fica no navegador (por usuário): sem migração de banco, e o pior caso — trocar de aparelho — é rever a novidade.
const chave = (user, sufixo) => `eairh_novidades_${sufixo}_${user?.id ?? "anon"}`;
const ler = (k) => { try { return new Set(JSON.parse(localStorage.getItem(k) || "[]")); } catch { return new Set(); } };
const gravar = (k, set) => { try { localStorage.setItem(k, JSON.stringify([...set])); } catch { /* modo privado */ } };

export const novidadesVistas = (user) => ler(chave(user, "vistas"));
export const marcarNovidadeVista = (user, id) => { const s = novidadesVistas(user); s.add(id); gravar(chave(user, "vistas"), s); };
// Quais já ABRIRAM SOZINHAS uma vez (sem contar como vistas): cada novidade se apresenta no máximo uma vez por conta própria.
export const novidadesAutoAbertas = (user) => ler(chave(user, "auto"));
export const marcarAutoAberta = (user, ids) => { const s = novidadesAutoAbertas(user); ids.forEach((i) => s.add(i)); gravar(chave(user, "auto"), s); };

export const dataCurta = (iso) => { const [a, m, d] = iso.split("-"); return `${d}/${m}/${a}`; };
